import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { Link, NavLink } from "react-router-dom";

import {
  FiTarget,
  FiBook,
  FiHeart,
  FiUmbrella,
  FiHome,
  FiTruck,
  FiDollarSign,
  FiInfo,
  FiFilter,
  FiChevronDown,
  FiAlertTriangle,
  FiArrowUp,
  FiArrowDown,
} from "react-icons/fi";

const GOAL_TYPES = [
  { id: "retirement", label: "Retirement", icon: FiDollarSign },
  { id: "education", label: "Education", icon: FiBook },
  { id: "marriage", label: "Marriage", icon: FiHeart },
  { id: "vacation", label: "Vacation", icon: FiUmbrella },
  { id: "general", label: "General", icon: FiTarget },
  { id: "home", label: "Home", icon: FiHome },
  { id: "vehicle", label: "Vehicle", icon: FiTruck },
];

export default function SetGoal() {
  const [activeTab, setActiveTab] = useState("goal-maker"); // goal-maker | map-asset | goal-status
  const [selectedGoalType, setSelectedGoalType] = useState("vehicle");

  // Goal Maker form
  const [goalName, setGoalName] = useState("");
  const [startDate, setStartDate] = useState("2026-02-10");
  const [targetDate, setTargetDate] = useState("");
  const [presentCost, setPresentCost] = useState("");
  const [inflation, setInflation] = useState("");
  const [expectedReturn, setExpectedReturn] = useState("");

  // Map Asset
  const [mapGoalName, setMapGoalName] = useState("");
  const [futureCost, setFutureCost] = useState(0);
  const [surplus, setSurplus] = useState(0);
  const [investLumpsum, setInvestLumpsum] = useState(0);
  const [investSip, setInvestSip] = useState(0);
  const [mapTargetDate, setMapTargetDate] = useState("");

  const formatINR = (amount) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(amount || 0);

  const handleSaveGoal = (e) => {
    e.preventDefault();
    // TODO: API call to save goal
    alert("Goal saved (integrate with API).");
  };

  const tabs = [
    { id: "goal-maker", label: "Goal Maker" },
    { id: "map-asset", label: "Map Asset" },
    { id: "goal-status", label: "Goal Status" },
  ];

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f8fafc" }}>
        <div className="container-fluid py-4">
          {/* Breadcrumb */}
          <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
            <div
              className="card-body p-4"

            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h3 className="text-primary mb-2">Set New Investment Goal</h3>
                  <nav
                    aria-label="breadcrumb"
                    style={{ "--bs-breadcrumb-divider": "none" }}
                  >
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <NavLink to="/overview">Dashboard</NavLink> /
                      </li>
                      <li className="breadcrumb-item active">Set Goal</li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="d-flex justify-content-around align-items-center mb-4 " style={{ borderBottom: "2px solid #e2e8f0",     background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
              padding: "16px",
              borderRadius: "12px",
              borderBottom: "3px solid #39b2b4",
               }}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                style={{
                  background: "none",
                  border: "none",
                  padding: "12px 0",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: activeTab === tab.id ? "#39b2b4" : "#64748b",
                  borderBottom: activeTab === tab.id ? "3px solid #39b2b4" : "3px solid transparent",
                  marginBottom: "-2px",
                  cursor: "pointer",
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Goal Maker */}
          {activeTab === "goal-maker" && (
            <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
              <div className="card-body p-4">
                {/* Goal categories */}
                <div className="d-flex mb-4 justify-content-around align-items-center">
                  {GOAL_TYPES.map((g) => {
                    const Icon = g.icon;
                    const isSelected = selectedGoalType === g.id;
                    return (
                      <button
                        key={g.id}
                        type="button"
                        onClick={() => setSelectedGoalType(g.id)}
                        style={{
                          width: "90px",
                          background: isSelected ? "#f0fdf4" : "#fff",
                          border: isSelected ? "2px solid #39b2b4" : "1px solid #e2e8f0",
                          borderRadius: "50%",
                          height: "90px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          boxShadow: isSelected ? "0 4px 12px rgba(57,178,180,0.2)" : "none",
                        }}
                      >
                        <Icon style={{ fontSize: "28px", color: "#39b2b4", marginBottom: "4px" }} />
                        <span style={{ fontSize: "11px", fontWeight: "600", color: "#1e293b" }}>{g.label}</span>
                      </button>
                    );
                  })}
                </div>

                {/* Current Goal form */}
                <h5 className="mb-4" style={{ color: "#1e293b", fontWeight: "700" }}>
                  Current Goal
                </h5>
                <div className="row g-4">
                  <div className="col-12 col-lg-12 p-4">
                    <form onSubmit={handleSaveGoal}>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Select Goal for :
                        </label>
                        <select
                          className="form-select"
                          value={selectedGoalType}
                          onChange={(e) => setSelectedGoalType(e.target.value)}
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        >
                          {GOAL_TYPES.map((g) => (
                            <option key={g.id} value={g.id}>
                              {g.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Name :
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={goalName}
                          onChange={(e) => setGoalName(e.target.value)}
                          placeholder="Goal name"
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Start Date :
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Target Date :
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={targetDate}
                          onChange={(e) => setTargetDate(e.target.value)}
                          placeholder="DD-MM-YYYY"
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Present Cost
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={presentCost}
                          onChange={(e) => setPresentCost(e.target.value)}
                          placeholder="Enter amount"
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Inflation
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={inflation}
                          onChange={(e) => setInflation(e.target.value)}
                          placeholder="%"
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="mb-4">
                        <label className="form-label" style={{ color: "#475569", fontWeight: "500" }}>
                          Expected Return
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={expectedReturn}
                          onChange={(e) => setExpectedReturn(e.target.value)}
                          placeholder="%"
                          style={{ borderRadius: "8px", borderColor: "#e2e8f0" }}
                        />
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          type="submit"
                          className="btn"
                          style={{
                            background: "#10b981",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 24px",
                            fontWeight: "600",
                          }}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          className="btn"
                          style={{
                            background: "#f1f5f9",
                            color: "#475569",
                            border: "1px solid #e2e8f0",
                            borderRadius: "8px",
                            padding: "10px 24px",
                            fontWeight: "600",
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
              
                </div>
              </div>
            </div>
          )}

          {/* Map Asset */}
          {activeTab === "map-asset" && (
            <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
              <div className="card-body p-4">
                <div className="mb-4">
                  <label className="form-label" style={{ color: "#475569", fontWeight: "600" }}>
                    Goal Name
                  </label>
                  <div className="position-relative">
                    <FiFilter
                      style={{
                        position: "absolute",
                        left: "14px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        color: "#94a3b8",
                        pointerEvents: "none",
                      }}
                    />
                    <select
                      className="form-select form-select-lg"
                      value={mapGoalName}
                      onChange={(e) => setMapGoalName(e.target.value)}
                      style={{
                        borderRadius: "8px",
                        borderColor: "#e2e8f0",
                        paddingLeft: "44px",
                      }}
                    >
                      <option value="">Select goal</option>
                      {GOAL_TYPES.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.label}
                        </option>
                      ))}
                    </select>
                    <FiChevronDown
                      style={{
                        position: "absolute",
                        right: "14px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "20px",
                        color: "#94a3b8",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="row g-3 mb-4">
                  {[
                    {
                      label: "Future Cost",
                      value: futureCost,
                      setValue: setFutureCost,
                      color: "#10b981",
                      icon: FiTarget,
                      showInfo: true,
                    },
                    {
                      label: "Surplus",
                      value: surplus,
                      setValue: setSurplus,
                      color: "#f59e0b",
                      icon: FiDollarSign,
                      showInfo: true,
                    },
                    {
                      label: "Invest Lumpsum",
                      value: investLumpsum,
                      setValue: setInvestLumpsum,
                      color: "#ef4444",
                      icon: FiDollarSign,
                      showInfo: false,
                    },
                    {
                      label: "Invest SIP",
                      value: investSip,
                      setValue: setInvestSip,
                      color: "#ef4444",
                      icon: FiDollarSign,
                      showInfo: false,
                    },
                  ].map((item) => {
                    const Icon = item.icon;
                    return (
                      <div key={item.label} className="col-6 col-md-3">
                        <div
                          className="p-3 rounded-3"
                          style={{
                            background: "#fff",
                            border: "1px solid #e2e8f0",
                            height: "100%",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <span style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b" }}>
                              {item.label}
                            </span>
                            {item.showInfo && (
                              <FiInfo style={{ fontSize: "14px", color: "#94a3b8", cursor: "pointer" }} />
                            )}
                          </div>
                          <div
                            className="d-flex align-items-center gap-2 mb-2"
                            style={{ color: "#1e293b", fontWeight: "700", fontSize: "18px" }}
                          >
                            <Icon style={{ fontSize: "20px", color: item.color }} />
                            {formatINR(item.value)}
                          </div>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            value={item.value || ""}
                            onChange={(e) => item.setValue(Number(e.target.value) || 0)}
                            placeholder="0"
                            style={{
                              border: "none",
                              borderBottom: `3px solid ${item.color}`,
                              borderRadius: 0,
                              paddingLeft: 0,
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="text-end">
                  <span style={{ color: "#64748b", fontWeight: "500" }}>Target Date :</span>
                  <input
                    type="date"
                    className="form-control d-inline-block ms-2"
                    value={mapTargetDate}
                    onChange={(e) => setMapTargetDate(e.target.value)}
                    style={{
                      width: "auto",
                      display: "inline-block",
                      borderRadius: "6px",
                      borderColor: "#e2e8f0",
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Goal Status */}
          {activeTab === "goal-status" && (
            <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none", overflow: "hidden" }}>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead>
                      <tr style={{ background: "#f8fafc" }}>
                        {[
                          "Goal",
                          "Goal Date",
                          "Years Left",
                          "Future Value Required",
                          "Completion Status (%)",
                          "Current Value",
                          "Running SIP Amount",
                          "Projected Value",
                          "Shortfall/Surplus",
                          "Lumpsum Invest",
                          "Add SIP",
                        ].map((head, i) => (
                          <th
                            key={head}
                            style={{
                              padding: "14px 16px",
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#475569",
                              borderBottom: "2px solid #e2e8f0",
                              background: head === "Goal Date" ? "rgba(57, 178, 180, 0.08)" : undefined,
                              borderLeft: head === "Goal Date" ? "2px solid #39b2b4" : undefined,
                            }}
                          >
                            <span className="d-inline-flex align-items-center gap-1">
                              {head}
                              <span className="d-inline-flex flex-column" style={{ fontSize: "10px" }}>
                                <FiArrowUp style={{ cursor: "pointer" }} />
                                <FiArrowDown style={{ cursor: "pointer", marginTop: "-4px" }} />
                              </span>
                            </span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={11} className="text-center py-5" style={{ color: "#64748b" }}>
                          <FiAlertTriangle
                            style={{ fontSize: "32px", color: "#f59e0b", marginBottom: "8px", display: "block", margin: "0 auto 8px" }}
                          />
                          No data available
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
